import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect } from 'react'
import { Toast } from 'react-bootstrap'

type TNotificationIcon = 'success' | 'warning' | 'error'
interface INotificationProps {
  show: boolean
  title: string
  message: string
  icon: TNotificationIcon
  onClose: () => void
}

const Notification: React.FC<INotificationProps> = ({
  show,
  title,
  message,
  icon,
  onClose,
}) => {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        onClose()
      }, 3000)
    }
  }, [show, onClose])

  const renderIcon = useCallback(() => {
    switch (icon) {
      case 'success':
        return <FontAwesomeIcon icon={faCheckCircle} color='#1ea01e' size='2x' />
      case 'warning':
        return (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color='var(--color-orange-light)'
            size='2x'
          />
        )
      case 'error':
        return <FontAwesomeIcon icon={faTimesCircle} color='var(--color-red)' size='2x' />
      default:
        return <FontAwesomeIcon icon={faCheckCircle} color='#1ea01e' size='2x' />
    }
  }, [icon])

  return (
    <div
      style={{
        display: show ? 'block' : 'none',
        width: '100%',
        position: 'fixed',
        left: '0',
        top: '0',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          paddingTop: '10px',
        }}
      >
        <Toast
          show={show}
          onClose={onClose}
          style={{ boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 30%)' }}
        >
          <Toast.Header style={{ padding: '16px' }}>
            {renderIcon()}
            <strong className='me-auto' style={{ marginLeft: '1rem', color: 'black' }}>
              {title}
            </strong>
          </Toast.Header>
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      </div>
    </div>
  )
}
export default Notification
